<template>
  <div v-if="!user || !user.business" class="container-fluid p-3 d-flex align-items-center justify-content-center min-vh-50">
    <b-spinner />
  </div>
  <div v-else class="container-fluid p-3">
    <div class="flex items-center justify-between"
      ><div
        ><h3 class="h3 my-0 mx-0 text-foreground"
          >Dashboard - {{ user.business.business_name }}</h3
        ><p class="text-muted-foreground text-sm"
          >Monitor your reputation management performance</p
        ></div
      >
      <div class="flex items-center space-x-4"
        ><div
          class="flex items-center space-x-2 bg-card border border-border round-xl px-3 py-2"
        >
          <i class="uil uil-calendar-alt"></i>
          <span class="text-sm font-medium">{{ currentDateRange }}</span>
        </div>
        <router-link
          :to="{
            name: 'request-reviews',
            params: {
              /* eslint-disable-next-line vue/camelcase */
              unique_id: user.business.unique_id + '-' + user.business.id,
            },
          }"
          class="btn bg-primary space-x-3 round-xl px-4 request-review-btn"
          target="_blank"
          ><i class="uil uil-star"></i
          ><span class="text-sm font-medium"> Request Review</span>
        </router-link></div
      >
    </div>
    <hr class="pb-4 pt-0" style="margin: 0 -40px 0 -20px !important;">
    <!-- Reviews Overview -->
    <div class="card mb-4 border round-2xl">
      <div class="card-body">
        <h3 class="h5 mb-4">Reviews Overview</h3>
        <div class="row g-4">
          <!-- Total Reviews -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-primary round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1 font-weight-bold"
                      >Total Reviews</p
                    >
                    <h4 class="mb-1 font-weight-bold">{{ totalReviews }}</h4>
                    <small class="text-gray">Started At {{ startedAt }}</small>
                  </div>
                  <div class="bg-primary bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-star text-primary"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- New Reviews Since Starting -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-success round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1 font-weight-bold"
                      >New Reviews Since Starting</p
                    >
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <h4 class="mb-0 font-weight-bold">{{
                        newSinceStarting
                      }}</h4>
                      <span
                        class="badge bg-success text-success bg-opacity-10 round-xl d-flex align-items-center"
                      >
                        <i
                          class="uil uil-arrow-growth me-1"
                          style="font-size: 12px"
                        ></i>
                        +{{ percentSinceStarting }}%
                      </span>
                    </div>
                    <small class="text-gray">All Time</small>
                  </div>
                  <div class="bg-success bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-arrow-growth text-success"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- New Reviews This Month -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-warning round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1 font-weight-bold"
                      >New Reviews This Month</p
                    >
                    <h4 class="mb-1 font-weight-bold">{{ newThisMonth }}</h4>
                    <small class="text-gray">This Month</small>
                  </div>
                  <div class="bg-warning bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-comment-alt text-warning"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rating Overview -->
    <div class="card mb-4 border round-2xl">
      <div class="card-body">
        <h3 class="h5 mb-4">Rating Overview</h3>
        <div class="row g-4">
          <div class="col-12 col-lg-6">
            <div
              class="card h-100 border-border/20 bg-warning round-xl bg-opacity-10"
            >
              <div class="card-body text-center">
                <p class="text-gray small mb-2">Current Rating</p>
                <h1 class="display-5 font-weight-bold mb-2">{{
                  currentRating.toFixed(1)
                }}</h1>
                <div class="mb-3">
                  <div class="text-warning">
                    <span v-for="n in 5" :key="n" style="font-size: 25px"
                      >&#9733;</span
                    >
                  </div>
                </div>
                <div
                  class="border-top bg-opacity-25 pt-3"
                  style="border-color: #ffbe0b30 !important"
                >
                  <div class="row">
                    <div class="col">
                      <h5>{{ totalReviews }}</h5>
                      <small class="text-gray">Total Reviews</small>
                    </div>
                    <div class="col">
                      <h5 class="text-gray">{{ changeThisMonth }}</h5>
                      <small class="text-gray">Change This Month</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div
              class="card h-100 border-border/20 bg-primary round-xl bg-opacity-0"
            >
              <div class="card-body d-flex flex-column">
                <h4 class="h6 mb-4">Rating Distribution</h4>
                <div class="space-y-between flex-grow-1">
                  <div
                    v-for="r in distribution"
                    :key="r.stars"
                    class="d-flex align-items-center gap-y-4"
                  >
                    <div
                      class="d-flex align-items-center gap-1"
                      style="min-width: 60px"
                    >
                      <span class="fw-medium">{{ r.stars }}</span>
                      <span class="text-warning" style="font-size: 16px"
                        >&#9733;</span
                      >
                    </div>
                    <div class="flex-grow-1">
                      <div class="progress" style="height: 0.75rem">
                        <div
                          class="progress-bar bg-warning"
                          :style="{ width: r.percent + '%' }"
                          role="progressbar"
                          :aria-valuenow="r.percent"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="text-gray small"
                      style="min-width: 80px; text-align: right"
                    >
                      {{ r.count }} ({{ r.percent }}%)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Engagement Metrics -->
    <div class="card mb-4 border round-2xl">
      <div class="card-body">
        <h3 class="h5 mb-4">Engagement Metrics</h3>
        <div class="row g-4">
          <!-- Card Taps -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-primary round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1">Card Taps</p>
                    <h4 class="mb-1">{{ tapsThisMonth }}</h4>
                    <small class="text-gray">This Month</small>
                  </div>
                  <div class="bg-primary bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-arrow-up-left text-primary"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- New Reviews -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-warning round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1">New Reviews</p>
                    <h4 class="mb-1">{{ newThisMonth }}</h4>
                    <small class="text-gray">This Month</small>
                  </div>
                  <div class="bg-warning bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-comment-alt text-warning"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Conversion -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-warning round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1">Conversion</p>
                    <h4 class="mb-1">{{ conversionRate }}%</h4>
                    <small class="text-gray">Tap to Review Rate</small>
                  </div>
                  <div class="bg-warning bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-arrow-growth text-warning"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Feedback Metrics -->
    <div class="card mb-4 border round-2xl">
      <div class="card-body">
        <h3 class="h5 mb-4">Feedback Metrics</h3>
        <div class="row g-4">
          <!-- Total Feedback -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-primary round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1">Total Feedback</p>
                    <h4 class="mb-1">{{ feedback.total }}</h4>
                    <small class="text-gray">This Month</small>
                  </div>
                  <div class="bg-primary bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-users-alt text-primary"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Positive Feedback -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-success round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1">Positive Feedback</p>
                    <h4 class="mb-1">{{ feedback.positive }}</h4>
                    <small class="text-gray">This Month</small>
                  </div>
                  <div class="bg-success bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-thumbs-up text-success"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Negative Feedback -->
          <div class="col-12 col-md-4">
            <div
              class="card h-100 border-border/20 bg-card/3 shadow-card bg-danger round-xl hover:shadow-md"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="text-gray small mb-1">Negative Feedback</p>
                    <h4 class="mb-1">{{ feedback.negative }}</h4>
                    <small class="text-gray">This Month</small>
                  </div>
                  <div class="bg-danger bg-opacity-10 p-2 round-xl">
                    <i
                      class="uil uil-thumbs-down text-danger"
                      style="font-size: 20px"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Reviews & Leaderboard -->
    <div class="row g-4">
      <!-- Recent Reviews -->
      <div class="col-12 col-lg-6">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="h5 mb-0">Recent Reviews</h3>
          <router-link :to="{ name: 'new-business.reviews' }" class="btn btn-link text-primary p-0 small">View all</router-link>
        </div>
        <div v-if="recentReviews.length === 0 && !loading" class="text-center py-8 text-muted-foreground">
          <p>No recent reviews found</p>
        </div>
        <div
          v-for="rev in recentReviews"
          :key="rev.id"
          class="mb-3"
        >
          <ReviewCard :review="rev" />
        </div>
      </div>

      <!-- Social post confirmation modal (for ReviewCard Share actions) -->
      <b-modal
        v-model="showSocialPostModal"
        :title="socialPostModalTitle"
      >
        <div v-if="postingItem">
          <p class="mb-3">{{ socialPostConfirmMessage(postingType) }}</p>
          <div><strong>Review Text: </strong><span v-html="postingItem.review_text"></span></div>
          <div v-if="postingType === 'instagram' && postingItem.instagram_post" class="mt-3">
            Posted to Instagram on {{ postingItem.instagram_post.front_date }}<br />
            Link: <a :href="'https://www.instagram.com/p/' + postingItem.instagram_post.ig_shortcode" target="_blank" rel="noopener noreferrer">https://www.instagram.com/p/{{ postingItem.instagram_post.ig_shortcode }}</a>
          </div>
          <div v-if="postingType === 'facebook' && postingItem.facebook_post" class="mt-3">
            Posted to Facebook on {{ postingItem.facebook_post.front_date }}<br />
            Link: <a :href="'https://www.facebook.com/' + postingItem.facebook_post.post_id" target="_blank" rel="noopener noreferrer">https://www.facebook.com/{{ postingItem.facebook_post.post_id }}</a>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="danger" @click="showSocialPostModal = false">Cancel</b-button>
          <b-button variant="success" @click="postSocial(postingItem, postingType)">
            <b-spinner v-if="postingItem && postingItem.working" small /> Post
          </b-button>
        </template>
      </b-modal>

      <!-- Leaderboard -->
      <div class="col-12 col-lg-6 h-100">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="h5 mb-0">Current Month Leaderboard</h3>
          <small class="text-gray">Card Taps</small>
        </div>

        <div v-if="leaderboard.length === 0 && !loading" class="text-center py-8 text-muted-foreground">
          <p>No leaderboard data available</p>
        </div>
        <div v-else class="vstack gap-y-3">
          <div
            v-for="(item, idx) in leaderboard"
            :key="`leaderboard-${idx}-${item.name}`"
            class="card h-100 shadow-card bg-primary round-xl"
            :style="getCardStyle(item)"
          >
            <div class="card-body align-items-center align-middle">
              <div
                class="d-flex justify-content-between align-items-center align-middle"
              >
                <div class="d-flex align-items-center gap-y-3 align-middle">
                  <!-- Medal Icon (Dynamic) -->
                  <div class="text-warning" style="width: 40px">
                    <i
                      :class="item.icon"
                      :style="{ fontSize: '20px', color: item.color }"
                    ></i>
                  </div>

                  <!-- User Initials Circle -->
                  <div
                    class="round-circle d-flex align-items-center justify-content-center"
                    :style="{
                      width: '40px',
                      height: '40px',
                      backgroundColor: item.color,
                    }"
                  >
                    <span class="small text-white">{{ item.initials }}</span>
                  </div>

                  <!-- User Info -->
                  <div>
                    <h6 class="mb-1">{{ item.name }}</h6>
                    <small class="text-gray">Rank #{{ idx + 1 }}</small>
                  </div>
                </div>

                <!-- Taps Info -->
                <div class="text-end">
                  <h5 class="mb-1">{{ item.taps }}</h5>
                  <small class="text-gray">taps</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../design/custom/components/_dashboard.scss'
import ReviewCard from './../Components/ReviewCard.vue'
import Vue from 'vue'
import axios from 'axios'
import {
  socialPostModalTitle,
  socialPostConfirmMessage,
} from '@utils/socialPostModal'

export default {
  name: 'Dashboard',
  components: { ReviewCard },
  data() {
    return {
      currentDateRange: '',
      loading: true,
      showSocialPostModal: false,
      postingItem: null,
      postingType: '',
      socialPostModalTitle,
      // Dashboard stats - will be populated from API
      totalReviews: 0,
      startedAt: 0,
      newSinceStarting: 0,
      percentSinceStarting: 0,
      newThisMonth: 0,
      currentRating: 0,
      changeThisMonth: '0.0',
      tapsThisMonth: 0,
      conversionRate: 0,
      feedback: { total: 0, positive: 0, negative: 0 },
      distribution: [
        { stars: 5, count: 0, percent: 0 },
        { stars: 4, count: 0, percent: 0 },
        { stars: 3, count: 0, percent: 0 },
        { stars: 2, count: 0, percent: 0 },
        { stars: 1, count: 0, percent: 0 },
      ],
      recentReviews: [],
      leaderboard: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    businessUniqueId() {
      return this.user?.business?.unique_id
    },
    businessId() {
      return this.user?.business?.id
    },
    meta() {
      return this.$store.getters['reviews/meta'] || {}
    },
  },
  provide() {
    return {
      createReply: (review) => this.createReply(review),
      rewriteReply: (review) => this.rewriteReply(review),
      saveReply: (review) => this.saveReply(review),
      confirmPostSocial: (review, type) => this.confirmPostSocial(review, type),
    }
  },
  mounted() {
    this.setCurrentDateRange()
    if (this.businessUniqueId && this.businessId) {
      this.fetchDashboardData()
    } else {
      console.warn('Business unique_id or id is missing')
      this.loading = false
    }
  },
  methods: {
    setCurrentDateRange() {
      const now = new Date()
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0)

      const options = { month: 'short', day: '2-digit', year: '2-digit' }
      const start = startOfMonth.toLocaleDateString('en-US', options)
      const end = endOfMonth.toLocaleDateString('en-US', options)

      this.currentDateRange = `${start} - ${end}`
    },
    async fetchDashboardData() {
      this.loading = true
      try {
        await Promise.all([
          this.fetchDashboardStats(),
          this.fetchRecentReviews(),
          this.fetchLeaderboard(),
        ])
      } catch (error) {
        console.error('Error fetching dashboard data:', error)
        if (this.$toast) {
          this.$toast.open({
            message: 'Failed to load dashboard data. Please try again.',
            type: 'error',
            duration: 5000,
          })
        }
      } finally {
        this.loading = false
      }
    },
    async fetchDashboardStats() {
      try {
        if (!this.businessUniqueId) {
          console.error('Business unique_id is required for dashboard stats')
          return
        }
        const response = await axios.get(`/re-stats/${this.businessUniqueId}`)
        
        if (!response.data || !response.data.success) {
          throw new Error('Invalid response from dashboard stats API')
        }
        
        const data = response.data.data || {}

        // Total reviews
        this.totalReviews = data.total || 0

        // Started at (reviews before starting date)
        this.startedAt = data.started_at_total || 0

        // New reviews since starting
        this.newSinceStarting = this.totalReviews - this.startedAt

        // Calculate percentage increase
        if (this.startedAt > 0) {
          this.percentSinceStarting = Math.round(
            (this.newSinceStarting / this.startedAt) * 100
          )
        } else {
          this.percentSinceStarting = this.totalReviews > 0 ? 100 : 0
        }

        // New reviews this month
        this.newThisMonth = data.this_period_reviews || 0

        // Current rating
        this.currentRating = data.average || 0

        // Change this month (rating change)
        const previousRating = data.non_period_rating || 0
        if (previousRating > 0) {
          this.changeThisMonth = (this.currentRating - previousRating).toFixed(1)
        } else {
          this.changeThisMonth = '0.0'
        }

        // Card taps this month
        this.tapsThisMonth = data.total_taps || 0

        // Conversion rate (reviews / taps * 100)
        if (this.tapsThisMonth > 0) {
          this.conversionRate = Math.round(
            (this.newThisMonth / this.tapsThisMonth) * 100
          )
        } else {
          this.conversionRate = 0
        }

        // Feedback metrics
        this.feedback = {
          total: data.feedback_total || 0,
          positive: data.feedback_positive || 0,
          negative: data.feedback_negative || 0,
        }

        // Rating distribution
        const overallRating = data.overall_rating || {}
        const total = this.totalReviews || 1

        this.distribution = [5, 4, 3, 2, 1].map((stars) => {
          const count = overallRating[stars] || 0
          const percent = Math.round((count / total) * 100)
          return { stars, count, percent }
        })
      } catch (error) {
        console.error('Error fetching dashboard stats:', error)
        throw error
      }
    },
    async fetchRecentReviews() {
      try {
        if (!this.businessId) {
          console.error('Business id is required for recent reviews')
          this.recentReviews = []
          return
        }
        const response = await axios.get(`/businessreviews/${this.businessId}`, {
          params: {
            per_page: 5,
            page: 1,
            sort_by: 'review_timestamp',
            sort_desc: true,
          },
        })

        const reviews = response.data?.data || []
        
        if (reviews.length === 0) {
          console.log('No reviews found in API response')
        }
        
        this.recentReviews = reviews.map((review) => ({
          id: review.id,
          author_title: review.author_title || 'Anonymous',
          author_image: review.author_image || null,
          review_rating: review.review_rating || 5,
          review_text: review.review_text || '',
          days_ago: this.formatDaysAgo(review.review_timestamp),
          platform: review.platform || 'Google',
          // Use API fields from ReviewResource so reply state matches Reviews tab
          reply: review.reply || null,
          writing_reply: review.writing_reply || false,
          replyText: review.reply || '',
          repliedAt: review.reply_updated
            ? this.formatDate(review.reply_updated)
            : null,
          waiting_4_ai: review.waiting_4_ai || false,
          stopped_typing: review.stopped_typing !== false,
          facebook_post: review.facebook_post || (review.facebook_shared_at ? { front_date: review.facebook_shared_at } : null),
          instagram_post: review.instagram_post || (review.instagram_shared_at ? { front_date: review.instagram_shared_at } : null),
          gbp_post: review.gbp_post || (review.google_shared_at ? { front_date: review.google_shared_at } : review.google_shared_at) || null,
          shared: {
            facebook: review.facebook_shared_at
              ? this.formatDate(review.facebook_shared_at)
              : null,
            instagram: review.instagram_shared_at
              ? this.formatDate(review.instagram_shared_at)
              : null,
            google: review.google_shared_at
              ? this.formatDate(review.google_shared_at)
              : null,
          },
        }))
      } catch (error) {
        console.error('Error fetching recent reviews:', error)
        // Don't throw - just set empty array
        this.recentReviews = []
      }
    },
    async fetchLeaderboard() {
      try {
        if (!this.businessUniqueId) {
          console.error('Business unique_id is required for leaderboard')
          this.leaderboard = []
          return
        }
        const response = await axios.get(`/leaderboard/${this.businessUniqueId}`)
        
        if (!response.data || !response.data.success) {
          throw new Error('Invalid response from leaderboard API')
        }
        
        const data = response.data.data || {}

        const employees = data.current_employees || []
        
        console.log('Leaderboard API response:', {
          data,
          employees,
          employeesLength: employees.length
        })
        
        if (employees.length === 0) {
          console.log('No employees found in leaderboard API response')
          this.leaderboard = []
          return
        }
        
        const icons = ['uil uil-trophy', 'uil uil-award', 'uil uil-medal']
        const colors = ['#FFD700', '#C0C0C0', '#CD7F32']
        const bgColors = [
          'rgba(255, 215, 0, 0.2)',
          'rgba(192, 192, 192, 0.2)',
          'rgba(205, 127, 50, 0.2)',
        ]

        // Only show actual employees, up to 3, no placeholders
        this.leaderboard = employees.slice(0, 3).map((employee, index) => ({
          name: employee.name || 'Unknown',
          initials: this.getInitials(employee.name || 'Unknown'),
          taps: employee.count || 0,
          icon: icons[index] || 'uil uil-medal',
          color: colors[index] || '#CD7F32',
          bgColor: bgColors[index] || 'rgba(205, 127, 50, 0.2)',
        }))
      } catch (error) {
        console.error('Error fetching leaderboard:', error)
        // Don't throw - just set empty array (no placeholders)
        this.leaderboard = []
      }
    },
    getInitials(name) {
      if (!name) return '??'
      const parts = name.trim().split(/\s+/)
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      }
      return name.substring(0, 2).toUpperCase()
    },
    formatTimeAgo(dateString) {
      if (!dateString) return 'Unknown'
      const date = new Date(dateString)
      const now = new Date()
      const diffMs = now - date
      const diffMins = Math.floor(diffMs / 60000)
      const diffHours = Math.floor(diffMs / 3600000)
      const diffDays = Math.floor(diffMs / 86400000)
      const diffMonths = Math.floor(diffDays / 30)

      if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`
      if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`
      if (diffDays < 30) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`
      if (diffMonths < 12) return `${diffMonths} month${diffMonths !== 1 ? 's' : ''} ago`
      return `${Math.floor(diffMonths / 12)} year${Math.floor(diffMonths / 12) !== 1 ? 's' : ''} ago`
    },
    formatDate(dateString) {
      if (!dateString) return null
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
    },
    formatDaysAgo(dateString) {
      if (!dateString) return 'Unknown'
      const date = new Date(dateString)
      const now = new Date()
      const diffMs = now - date
      const diffDays = Math.floor(diffMs / 86400000)
      const diffMonths = Math.floor(diffDays / 30)
      const diffYears = Math.floor(diffMonths / 12)

      if (diffDays === 0) return 'Today'
      if (diffDays === 1) return '1 day ago'
      if (diffDays < 30) return `${diffDays} days ago`
      if (diffMonths === 1) return '1 month ago'
      if (diffMonths < 12) return `${diffMonths} months ago`
      if (diffYears === 1) return '1 year ago'
      return `${diffYears} years ago`
    },
    getCardStyle(item) {
      return {
        backgroundColor: item.bgColor
          ? item.bgColor + ' !important'
          : '#ffffff !important',
        borderColor: item.color ? item.color : '#e0e0e0',
        borderWidth: '1px',
      }
    },
    socialPostConfirmMessage,
    confirmPostSocial(review, type) {
      if (this.meta && this.meta.can_social_post === false) {
        Vue.$toast.open({
          message: 'Sorry, you have reached your post limit.',
          type: 'error',
          duration: 5000,
        })
        return
      }
      this.postingItem = review
      this.postingType = type
      this.showSocialPostModal = true
    },
    postSocial(review, type) {
      if (!review) return
      review.working = true
      this.$store
        .dispatch('reviews/postSocial', {
          type: type,
          review_id: review.id,
          user_id: this.user.id,
          business_id: this.user.business.id,
        })
        .then((res) => {
          review.facebook_post = res.facebook_post
          review.instagram_post = res.instagram_post
          review.gbp_post = res.gbp_post
          review.working = false
          this.showSocialPostModal = false
        })
        .catch((res) => {
          review.working = false
          console.log(res)
        })
    },
    createReply(review) {
      if (this.meta && this.meta.can_reply_engine === false) {
        Vue.$toast.open({
          message: 'Sorry, you have reached your reply limit.',
          type: 'error',
          duration: 5000,
        })
        return
      }
      review.working = true
      review.writing_reply = true
      review.waiting_4_ai = true
      review.stopped_typing = false
      review.openai_error = null
      review.editing = false
      this.$store
        .dispatch('reviews/getReply', {
          review: review.review_text,
          reviewers_name: review.author_title,
          review_stars: (review.review_rating || 5) + ' out of 5 stars. ',
          business: this.user?.business?.id,
        })
        .then((res) => {
          review.reply = res.data.reply
          review.replyText = res.data.reply
          review.working = false
          review.waiting_4_ai = false
          if (res.data.error) review.openai_error = res.data.error
        })
        .catch(() => {
          review.working = false
          review.writing_reply = false
          review.waiting_4_ai = false
          review.stopped_typing = true
        })
    },
    rewriteReply(review) {
      if (this.meta && this.meta.can_reply_engine === false) {
        Vue.$toast.open({
          message: 'Sorry, you have reached your reply limit.',
          type: 'error',
          duration: 5000,
        })
        return
      }
      review.working = true
      review.writing_reply = true
      review.waiting_4_ai = true
      review.stopped_typing = false
      review.openai_error = null
      review.editing = false
      this.$store
        .dispatch('reviews/rewriteReply', {
          review: review.review_text,
          reviewers_name: review.author_title,
          review_stars: (review.review_rating || 5) + ' out of 5 stars. ',
          business: this.user?.business?.id,
        })
        .then((res) => {
          review.reply = res.data.reply
          review.replyText = res.data.reply
          review.working = false
          review.waiting_4_ai = false
          if (res.data.error) review.openai_error = res.data.error
        })
        .catch(() => {
          review.working = false
          review.writing_reply = false
          review.waiting_4_ai = false
          review.stopped_typing = true
        })
    },
    saveReply(review) {
      review.working = true
      this.$store
        .dispatch('reviews/saveReply', { review })
        .then((res) => {
          // Update local review with latest values from API so Updated label reflects correctly
          review.reply = res.reply
          review.replyText = res.reply
          review.reply_updated = res.reply_updated
          review.repliedAt = res.reply_updated
          review.working = false
          review.editing = false
        })
        .catch(() => {
          review.working = false
        })
    },
  },
}
</script>
